import * as React from 'react'

import WpApi from './wpapi'
import Loader from './Loader'
import Loco from './Loco'
import DdBlockAspect from  './DdBlockAspect'
import {BlockType} from './types'
import FilteredChoices from './filtered_choices'
import Expander_helper from './Expander_helper'
import Date_formatting from './Date_formatting'
import BlockCounter from './BlockCounter'
import Styled_label from './Styled_label'

interface MyProps {
    tup:any,
    postid:number,
    readonly:boolean,   // in case of archive-mode
    options:any,
    permission:any,
    measure?:any,
    level1:any,
    level2:any,
    cb_parent:   (e: any, cb: (r: any) => void) => void
}
type MyState = {
    supplier:string,
    supplier_choices: any,
    hideme:boolean,
    product:string,
    product_choices:any,
    is_loading:boolean,
    message:string,
    value_huidig:string,
    value_count_huidig:number,
    value_huidig_lab:string
    
}
class QuotationBlock extends React.PureComponent<MyProps,MyState> {
    constructor(props: MyProps) {
        super(props)
	this.handle_cb = this.handle_cb.bind(this)
	this.handle_select_supplier = this.handle_select_supplier.bind(this)
	this.handle_select_bouwdeel = this.handle_select_bouwdeel.bind(this)
	this.show_product_dropdown = this.show_product_dropdown.bind(this)
	this.handle_select_product = this.handle_select_product.bind(this)
	this.update_label_huidig = this.update_label_huidig.bind(this)

	this.handle_cancel_click = this.handle_cancel_click.bind(this)
	this.state = {
	    supplier:'',
	    value_huidig:'',
	    value_count_huidig:0,
	    value_huidig_lab:'',
	    message:'',
	    product:'',
	    hideme:false,
	    supplier_choices:{},
	    product_choices:{},
	    is_loading:false
	}
    }

    // pass-on the signal from QuotationStatus
    handle_cb(e:any,cb:(r:any)=>void){
	/*
	if(e.votetype==='choice-on-attr'){
	    WpApi.do_post('/hd-attr',e, (r:any) => {
		console.log('vote-ret')
		this.update_state_huidig(r)
		cb(r)
	    })
	    return
	}
	*/
	if(e.cmd === "set-action-status"){
	    if(e.aspect === "huidig"){
		console.log("set-action-status huidig")
		this.update_state_huidig(e)
	    }else{
		console.log("set-action-status niet huidig")
	    }
	}
	e.popup_label = {
	    template: "quotation-step",
	    parts: this.get_label_parts()
	}
	if(e.cmd === "on-attr-choice-vote"){
	    e.history_popup.assignable_choices = this.state.supplier_choices
	}
	if(e.cmd === "open-history"){
	    e.assignable_choices = this.state.supplier_choices
	}
	/*
	if(e.cmd === "quotation-status-vote"){
	    console.log("cmd q-status-vote")
	    e.history_popup.assignable_choices = this.state.supplier_choices
	    e.post_id = this.props.postid
	}
	*/
	this.props.cb_parent(e,(r:any)=>{
	    if(e.cmd === "on-attr-choice-vote"){
		console.log("return from q-status-vote")
		this.update_state_huidig(r)
	    }
	    cb(r)
	})
	
    }
    handle_simplerow_click(row:any){
	console.log('clicked')
	let slug = row.name

	this.props.cb_parent({
	    cmd: 'set-quotation-status',
	    value: slug,
	    on_attr_id: this.props.tup.attr_id,
	    acf_key: this.props.options.quotation.key
	},(r:any)=>{
	    if(r.winner){
		console.log(`got  winner ${r.winner}`)
		this.setState({
		    value_huidig: r.winner,
		    is_loading:false
		})
	    }
	})
    }
    // hulplijst produkt
    handle_select_product(e:any){
	console.log('selected product')
	let slug = e.target.value
	console.log(`changed dropdown to: ${slug}`)
	console.log(`changed dropdown to: ${slug}`)
	let d = {
	    post_id : this.props.postid,
	    votetype: 'choice-on-attr',
	    value: slug,
	    aspect: 'huidig',
	    acf_key: this.props.options.produkt.key,
	    is_final_field: "false",
	    trigger_recalc: "false",
	    on_attr_id: this.props.tup.attr_id,
	}
	console.log('set is loading true')
	this.setState({ is_loading:true})
	WpApi.do_post('/hd-attr',d, (r:any) => {
	    this.setState({
		is_loading:false,
		product:r.winner
	    })
	})
	
    }
    handle_cancel_click(){
	console.log('handle cancel')
	let d = {
	    action : 'delete-row',
	    attr_id: this.props.tup.attr_id
	}
	WpApi.do_post('/hd-repeaterbase',d, (r:any) => {
	    console.log(r)
	    if(r.status === 'ok'){
		this.setState({ hideme:true})
	    }else{
		this.setState({'message':r.message})
	    }
	});
    }
    // hulplijst supplier
    handle_select_supplier(e:any){
	console.log('selected supplier')
	let slug = e.target.value
	console.log(`changed dropdown to: ${slug}`)
	let d = {
	    post_id : this.props.postid,
	    votetype: 'choice-on-attr',
	    value: slug,
	    aspect: 'huidig',
	    acf_key: this.props.options.leverancier.key,
	    is_final_field: "false",
	    trigger_recalc: "false",
	    on_attr_id: this.props.tup.attr_id,
	}
	console.log('set is loading true')
	this.setState({ is_loading:true})
	WpApi.do_post('/hd-attr',d, (r:any) => {
	    this.setState({
		is_loading:false,
		supplier:r.winner
	    })
	})
    }
    handle_select_bouwdeel(e:any){
	console.log('selected bouwdeel')
	let slug = e.target.value
	console.log(`changed dropdown to: ${slug}`)
	let d = {
	    post_id : this.props.postid,
	    votetype: 'choice-on-attr',
	    value: slug,
	    aspect: 'huidig',
	    acf_key: this.props.options.bouwdelen.key,
	    is_final_field: "false",
	    trigger_recalc: "false",
	    on_attr_id: this.props.tup.attr_id,
	}
	console.log('set is loading true')
	this.setState({ is_loading:true})
	WpApi.do_post('/hd-attr',d, (r:any) => {
	    this.setState({
		is_loading:false,
		supplier:r.winner
	    })
	})
	
    }
    archive_delete(){
	let q_perm = this.props.permission.quotation.huidig

	if(this.props.readonly && q_perm.edit.current_user){
	    return (
		<div><span className="normal-color cf-button" onClick={this.handle_cancel_click}
		>Verwijder deze Offerte-aanvraag</span></div>
	    )
	}
    }
    componentDidMount(){
	let atup = this.props.tup
	let filter = new FilteredChoices(
	    this.props.level1.name,
	    this.props.level2.name)

	this.update_label_huidig(atup.huidig.value)

	this.setState({
	    supplier_choices: filter.filtered_choices(this.props.options.leverancier.buttons),
	    product_choices:  filter.filtered_choices(this.props.options.produkt.buttons),
	    value_huidig: atup.huidig.value,
	    value_count_huidig: atup.huidig.value_count,
	    product: atup.produkt,
	    supplier: atup.supplier

	})
    }
    update_label_huidig(v:string){
	let choices = this.props.tup.huidig.choices
        if(choices !== undefined && v in choices){
            this.setState({ 'value_huidig_lab': choices[v]})
        }
    }
    update_state_huidig(r:any){
	if(r.winner){
	    this.update_label_huidig(r.winner)
	    if(r.aspect=== "huidig"){
		this.setState({value_huidig:r.winner, value_count_huidig:r.value_count})
	    }
	}
    }
    
    is_expanded(){
	if(this.props.options.config !== undefined){
	    let conf = this.props.options.config
	    if(conf.attr === this.props.tup.attr_id){
		return true
	    }
	}
	let tup = this.props.tup

	if(tup.uistate !== undefined && tup.uistate === "new"){
	    return true
	}
	return false
    }
    with_measure() :boolean{
		return false
	return (! (
		    this.props.measure === undefined 
		    || this.props.measure ===null
		))
    }

    render_bouwdeel_dropdown(){
	let choices = this.props.options.bouwdelen.choices
	return (

		<select style={{height:'unset'}} onChange={this.handle_select_bouwdeel}>
		<option value="">-kies-</option>

	    </select>

	)
	

    }
    show_product_wtw_archive(){
	if(this.props.level1.classes !== undefined && this.props.level1.classes.includes('quot-archive-wtw')){
	    let prod = this.state.product
	    let opts = this.props.options.produkt.buttons
	    let fopts = opts.filter((x:any) => (
		x.name === prod
	    ))
	    let prodlabel = ""
	    if(fopts.length > 0){
		prodlabel = fopts[0].label
	    }
	    if(prodlabel !== ""){
    		return (
		    <div className="aux-option">
		       <div className="label">Betreft produkt:</div>
		       <div className="value">{prodlabel}</div>
		    </div>
    		)
	    }
	}
	return null
    }
    show_product_dropdown() : boolean {
	let choices = this.state.product_choices
	let len = Object.entries(choices).length
	return (len > 0)
    }
    render_produkt_dropdown(){
	let choices = this.state.product_choices
	let product = this.state.product
	let has_status = this.state.value_huidig !== "kies"

	if(product && has_status){
	    return (
		<div className="label">{choices[product]}</div>
	    )
	}
	let product_value = product===null ? '' : product
	return (

		<select value={product_value} style={{height:'unset'}} onChange={this.handle_select_product}>
		<option value="">-kies-</option>
		{Object.entries(choices).map(([cname,clabel]:[string,any],i:number) => {
		    return (<option key={i} value={cname}>{clabel}</option>)
		})}
	    </select>

	)

    }
    get_supplier_label(){
	let choices = this.state.supplier_choices
	let supplier = this.state.supplier
	if(supplier){
	    return choices[supplier]
	}
	return choices['onbepaald']

    }
    get_total_vote_count(){
	let tup = this.props.tup.huidig
	let count_huidig = tup.value_count + tup.comment_count
	return count_huidig + this.get_voorstel_vote_count()
    }
    get_voorstel_vote_count(){
	let tup = this.props.tup.voorstel
	return tup.value_count + tup.comment_count
    }
    render_supplier_dropdown(){
	let choices = this.state.supplier_choices
	let supplier = this.state.supplier
	let supplier_value = supplier === null ? '' : supplier
	let has_status = this.state.value_huidig !== "kies"

	let perm = this.props.permission.assign_quotation
	if(perm.view === undefined){
	    console.log('ERROR, no perm for assign_quotation')
	    return (<div className="label permission-denied">[error x1]</div>)
	}
	if(!perm.view.current_user){
	    return (<div className="label permission-denied">[geen toegang]</div>)
	}
	let show_readonly = this.props.readonly || ! perm.edit.current_user
	// make it readonly in case the assigned supplier has attributed in aspect 'voorstel' 
	if(supplier_value !== ''){
	    if(this.get_voorstel_vote_count() > 0){
		return (
	    	    <div className="label">
		       {this.get_supplier_label()}
		       <span className="notify"> (Nb. je kan dit niet meer wijzigen)</span>
		    </div>
	       	)
	    }
	}

	if(show_readonly){
	    return (
		<div className="label">{this.get_supplier_label()}</div>
	    )
	}
	return (

		<select value={supplier_value} style={{height:'unset'}} onChange={this.handle_select_supplier}>
		<option value="">-kies-</option>
		{Object.entries(choices).map(([cname,clabel]:[string,any],i:number) => {
		    return (<option key={i} value={cname}>{clabel}</option>)

		})}
	    </select>

	)
    }
    render_qstatus(asp:string,tup:any){
	let cfg = this.props.options.config
	let ui_type = ""
	if(cfg !== undefined){
	    if(cfg.block_ui_type !== undefined){
		ui_type = cfg.block_ui_type
	    }
	}
	let opt = this.props.options.quotation
	let stup = {
	    classes: [],
	    choices : opt[asp].options.choices,
	    section_name: ''
	}
	// Note: assigning choices + buttons to asptup will also show up
	//   in QuotationsAndCustomersRow's prop row
	//   and even in  QuotationsAndCustomers prop rows
	let asptup = tup[asp]
	asptup.active = true
	asptup.choices =  opt[asp].options.choices
	asptup.buttons = {
	    classes: ["show-all-buttons"],
	    list: opt[asp].buttons.buttons
	}
	
	return (
	    <DdBlockAspect
		aspect={asp}
		popup_label="quotation-step"
		acfkey={opt.key}
		type={BlockType.Quotation}
		mode={""}
		stup={stup}
		readonly={this.props.readonly}
		l2cluster={this.props.level2}
		permission={this.props.permission.implementation[asp]}
		on_attr_id={this.props.tup.attr_id}
		options={this.props.options}
		cb_parent={this.handle_cb}
		tup={asptup}
		post_id={this.props.postid}

	    />
	)

    }
    get_trash_button(){
	if(!this.props.readonly && this.get_total_vote_count() === 0 ){
	    return (
    		<div className="buttons">
		    <span data-balloon="Verwijder keuze" data-balloon-pos="up" 
		    onClick={this.handle_cancel_click}
			className="cf-icon-btn icon-large">
			<i className="bb-icon-l bb-icon-trash"/>
		    </span>
		</div>
	    )
	}

	return null
    }
    get_label(){
	let p = this.get_label_parts()
	if(this.is_simple_ui_block()){
	    return `${p.pre} van ${p.date}`
	}
	return `${p.pre} voor ${p.maatregel} voor ${p.subtopic} ${p.bd_txt} van ${p.date},  aan leverancier: ${p.supplier}`
    }
    get_label_parts_simple(): {[k:string]:string}{
	let d1 = new Date(this.props.tup.time) 
	let date = (new Date_formatting()).get_formatted_d(d1)
	let pre = 'Offerte(-aanvraag)'
	if(this.props.readonly){
	    pre = 'OUDE OPZET (zonder maatregelkeuze) Offerte-aanvraag'
	}
	let supplier = this.get_supplier_label()
	return {
	    pre: pre,
	    date: date,
	    supplier: supplier
	}
    }
    get_label_parts(): {[k:string]:string}{
	// Offerte(-aanvraag) voor [potentiele maatregel] voor [SUB-TOPIC]  (voor Woningonderdeel [WONINGDEEL])  van [datum], aan leverancier: [naam leverancier] [verwijder offerte icoontje]					
	let supplier = this.get_supplier_label()
	let d1 = new Date(this.props.tup.time) 
	let date = (new Date_formatting()).get_formatted_d(d1)
	let pre = 'Offerte(-aanvraag)'
	if(this.props.readonly){
	    pre = 'OUDE OPZET (zonder maatregelkeuze) Offerte-aanvraag'
	}

	let bd_txt = this.get_bouwdeel_label()
	let maatregel = ""
	if(this.props.measure !== null){
	    maatregel = this.props.measure.text
	}
	let subtopic = this.props.level2.label

	return {
	    pre: pre,
	    status: this.state.value_huidig,
	    status_lab: this.state.value_huidig_lab,
	    maatregel: maatregel,
	    subtopic: subtopic,
	    buildingpart: bd_txt,
	    date: date,
	    supplier: supplier
	}

    }

    is_simple_ui_block(){
	let cfg = this.props.options.config
	if(cfg !== undefined && cfg.block_ui_type !== undefined){
    	    return cfg.block_ui_type === "simple"
	}
	return false
    }
    get_bouwdeel_label(){
	let bd = this.props.tup.bouwdeel
	if(bd !== "" && bd !== "hele_woning"){
	    let bdopt = this.props.options.buildingparts.buttons.filter((x:any) => x.name === bd)
	    if(bdopt.length> 0){
		return bdopt[0].label
	    }
	}
	return ""
    }
    render(){
	if(this.state.hideme){
	    return null
	}
	let tup = this.props.tup
	let exp = new Expander_helper();
	let label_parts = this.is_simple_ui_block() 
	    ? this.get_label_parts_simple()
	    : this.get_label_parts()


	let label = <Styled_label template="quotation-step" parts={label_parts} />
	let classes = ""
	let bd_txt = this.get_bouwdeel_label()
	
	let view = ""
	let show_which_supplier = true
	if(this.props.options.config !== undefined){
	    view = this.props.options.config.view
	    if(this.props.options.config.single_supplier_mode !== undefined){
		if(this.props.options.config.single_supplier_mode){
		    show_which_supplier = false
		}
	    }
	}
	let cluster_label = this.props.level2.label === undefined 
           ? this.props.level1.label 
           : this.props.level2.label

	if( !this.is_expanded()){
	    classes += " collapsed"
	}

	if(this.props.readonly){
	    classes += " archive"
	}
	else if(view === "quotations-listgrid"){
	    classes = ""
	}


	let counter = <BlockCounter 
	    value_label={this.state.value_huidig_lab}
	    value_count={this.state.value_count_huidig}
	    />
	let trash_btn = this.get_trash_button()
	let label_elm = (
	    <div className="label with-counter" onClick={exp.toggle_expand}>
		<div className="keep-inline">
		    {label}
		    {this.is_simple_ui_block() ? this.render_supplier_dropdown() : null}
		</div>
		{counter}
	    </div>
	)
	if(trash_btn !== null){
	    label_elm = (
	    	<div className="label space-between">
	    	    <div className="keep-inline">
	    		<div onClick={exp.toggle_expand}> {label}</div>
	    		{this.is_simple_ui_block() ? this.render_supplier_dropdown() : null}
	    	    </div>
	    	    {trash_btn}
		</div>
	    )
	}

			let aux_subtopic = (
			<div className="aux-option">
			    <div className="label">Voor:</div>
			    <div className="value">
			    <Styled_label template="subtopic-building" 
			      parts={{subtopic: cluster_label,buildingpart:bd_txt}} />
			    </div>
			</div>

			)

    	return (
	    <div className={"step quotation with-expand "+classes}>
		<div className="header" >
		    <div className="pre-icon" onClick={exp.toggle_expand}></div>
		    {label_elm}
		</div>
		<div className="body">
		{this.is_simple_ui_block() ? null : (
		    <div className="aux-options">
			{this.with_measure() ? (
			<div className="aux-option">
			    <div className="label">Betreft (potentiële) Maatregel:</div>
			    <div className="value"><b>{this.props.measure.text}</b> </div>
			</div>
			): null}
			{show_which_supplier ? (
			<div className="aux-option">
			    <div className="label">Betreft welke Leverancier:</div>
			    {this.render_supplier_dropdown()}
			</div>
			) : null} 
			{this.show_product_wtw_archive()}

			{this.show_product_dropdown() ? (
			    <div className="aux-option">
				<div className="label">Kies (merk-) produkt:</div>
				{this.render_produkt_dropdown()} 
			    </div>
			) : null}
		    </div>
		)}

			<div className="aspects default quotation-status two-columns">
			    {this.render_qstatus('huidig',tup)}
			    {this.render_qstatus('voorstel',tup)}
			</div>
		    
	    {this.state.message !== '' ? (<div className="cfmessage warning">{this.state.message}</div>):null}
	    {this.archive_delete()}
		
	    </div>
	    </div>	    
		
	)
    }
}
export default QuotationBlock;

